const getParentAnswerList = () => {
	try {
		return JSON.parse(localStorage.parentAnswerList);
	} catch (e) {
		return []
	}
}
const getPageMessage = () => {
	try {
		return JSON.parse(localStorage.pageMessageObj);
	} catch (e) {
		return {}
	}
}
const getRadio = () => {
	try {
		return JSON.parse(localStorage.radio);
	} catch (e) {
		return ''
	}
}
export default {

	pageSizesList: [10, 20, 30, 50],
	pageSizesDefault: 10,
	loadingOptions: {
		lock: true,
		text: 'Loading',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.6)'
	},

	Authorization: '',//token




	menu: null, //菜单数据
	menuObject: {}, //菜单对象(菜单code和数据对应)
	routesPrivilege: [], //路由权限数据
	menuBtnPrivilege: [],//按钮的全部权限。

	orgId: '',//用户id
	orgCode: '',//机构代码

	isLoading: false,

	parentAnswer: getParentAnswerList(),
	pageMessage: getPageMessage(),
	
	// {
	// 	"第一页":[

	// 	],
	// 	"第二页":[

	// 	]
	// }
	radio: getRadio()
}
